export const getCookie = (name: string) => {
  const matches = window.document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`),
  );

  if (!matches) {
    return undefined;
  }

  try {
    return decodeURIComponent(matches[1]);
  } catch {
    return matches[1];
  }
};
